module.exports = __webpack_public_path__ + "static/media/menu.6d85dc97.svg";